module.exports = "<p>\n  npspromotion-edit works!\n</p>\n"